export default __webpack_public_path__ + "static/media/classify-jerwin.c6e83c11.jpg";